// eslint-disable-next-line no-extend-native
String.prototype.toLowerUnderscoreCase = function () {
    return this.toString().trim().toLowerCase().split(" ").join("_");
}
//.replace(/[^a-z0-9:]+/gi, "_")
